import React from 'react'
import { connect } from 'react-redux'
import { Field, change, getFormValues } from 'redux-form'
import { Fade } from '@material-ui/core'
import { Icon, Button, Confirm, Modal } from 'semantic-ui-react'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard } from 'components'
import { purchaseOrderDetailPath } from 'routes'
import { getPOURequestTypes } from 'ducks/poUpdate'

import { ProcurementBody } from 'routes/ProcurementSystem/styled'
import { 
  Container,
  RowHeader,
  RowHeader_,
  RowData_,
  RowData,
  RowNF
} from './styled'
import r from 'reactotron-react-js'

const GeneralInfo = props => {
  const {
    poComplete,
    valueForm,
    change,
    poCompleteDetail,
    //props
    isCreate = false,
    isEdit = false,
    isDetail = false,
  } = props

  const [requestTypeList, setRequestTypeList] = React.useState([])
  // confirm for clear request type when select RT01 after selected other RT
  const [showConfirm01, setShowConfirm01] = React.useState(false)
  // Warning when select RT01 and po has Contract or DownPayment
  const [showConfirm02, setShowConfirm02] = React.useState(false)
  // Warning when select RT01 and po has GR complete
  const [showAlertHasGR, setShowAlertHasGR] = React.useState(false)
  //for check showed alert
  const [showedAlert, setShowedAlert] = React.useState(false)

  React.useEffect(()=>{
    props.getPOURequestTypes()
  },[])

  //check poDetail has contract or downPayment after select requestype RT01
  React.useEffect(() => {
    if(poCompleteDetail){
      if(valueForm.requestTypes){
        let index = valueForm.requestTypes.findIndex(x=>{
          if(x.code){
            return x.code.localeCompare('RT01')==0&&!x.deleted
          }else{
            return false
          }
        })>=0
        if(index){
          if(poCompleteDetail.grComplete){
            if((isCreate||isEdit)){
              setShowAlertHasGR(true)
              clearRequestType()
            }
          }else if(poCompleteDetail.contract || poCompleteDetail.downPayment){
            if((isCreate||isEdit) && !showedAlert){
              setShowConfirm02(true)
              setShowedAlert(true)
            }
          }
        }
      }
    }
  },[poCompleteDetail])

  // setUp requestType list row by row
  React.useEffect(()=>{
    if(valueForm&&valueForm.requestTypes&&props.pouRequestTypes ){
      let cloneRequestTypeList = JSON.parse(JSON.stringify(requestTypeList))
      valueForm.requestTypes.forEach((x,index) => {
        if(x.code&&!x.deleted){
          let temp = props.pouRequestTypes.filter(i=>valueForm.requestTypes.findIndex(ii=>ii.code==i.code&&!ii.deleted)<0)
          let indexSelected = props.pouRequestTypes.findIndex(i=>i.code==x.code)
          temp.splice(indexSelected, 0, props.pouRequestTypes[indexSelected])
          cloneRequestTypeList[index] = temp
          setRequestTypeList(cloneRequestTypeList)
        }else{
          cloneRequestTypeList[index] = props.pouRequestTypes.filter(i=>valueForm.requestTypes.findIndex(ii=>ii.code==i.code&&!ii.deleted)<0)
          setRequestTypeList(cloneRequestTypeList)
        }
      });
    }
  },[valueForm&&valueForm.requestTypes,props.pouRequestTypes])

  //check select requestType 'cancelPO' after selected other requestType
  React.useEffect(()=>{
    if(valueForm&&valueForm.requestTypes){
      let result = valueForm.requestTypes.findIndex(x=>{
        if(x.code){
          return x.code.localeCompare('RT01')==0&&!x.deleted
        }else{
          return false
        }
      })>=0
      if(result){
        if(poCompleteDetail){
          if(poCompleteDetail.grComplete && valueForm.requestTypes.filter(x=>!x.deleted).length==1){
            if((isCreate||isEdit)){
              setShowAlertHasGR(true)
              clearRequestType()
            }
          }else if((poCompleteDetail.contract || poCompleteDetail.downPayment) && valueForm.requestTypes.filter(x=>!x.deleted).length==1){
            if((isCreate||isEdit) && !showedAlert){
              setShowConfirm02(true)
              setShowedAlert(true)
            }
          }else{
            setShowedAlert(false)
          }
        }
        if(valueForm.requestTypes.filter(x=>!x.deleted).length>1){
          if(isCreate||isEdit){
            setShowConfirm01(true)
          }
        }
      }
    }
  },[valueForm&&valueForm.requestTypes])


  const checkRequestTypeIsCancelPO = ()=>{
    if(valueForm&&valueForm.requestTypes){
      return valueForm.requestTypes.findIndex(x=>{
        if(x.code){
          return x.code.localeCompare('RT01')==0&&!x.deleted
        }else{
          return false
        }
      })>=0
    }else{
      return false
    }
  }

  const clearRequestType = () =>{
    let requestTypes = []
    valueForm.requestTypes.forEach(x=>{
      if(x.id){
        requestTypes.push({
          ...x,
          deleted:true
        })
      }
    })
    setRequestTypeList([])
    change('formPOUpdate','requestTypes',requestTypes)
  }

  // on accept confirm01 will clear request type
  const onAcceptConfirm01 = () =>{
    setShowConfirm01(false)
    let requestTypes = []
    valueForm.requestTypes.forEach(x=>{
      if(x.id){
        requestTypes.push({
          ...x,
          deleted:x.code!='RT01'?true:false
        })
      }
    })
    if(poCompleteDetail.grComplete){
      if((isCreate||isEdit)){
        setShowAlertHasGR(true)
        clearRequestType()
      }
    }else if(poCompleteDetail.contract || poCompleteDetail.downPayment){
      if((isCreate||isEdit) && !showedAlert){
        setShowConfirm02(true)
        setShowedAlert(true)
      }
    }
    setRequestTypeList([props.pouRequestTypes])
    change('formPOUpdate','requestTypes',requestTypes)
  }

  // on accept confirm01 will clear request type
  const onRejectConfirm01 = () =>{
    setShowConfirm01(false)
    //set RequestTypes
    let cloneRequestTypes = JSON.parse(JSON.stringify(valueForm.requestTypes))
    let index = cloneRequestTypes.findIndex(x=>{
      if(x.code){
        return x.code.localeCompare('RT01')==0&&!x.deleted
      }else{
        return false
      }
    })
    cloneRequestTypes[index].code = ''
    change('formPOUpdate','requestTypes',cloneRequestTypes)
    //set requestTypeList
    let cloneRequestTypeList = JSON.parse(JSON.stringify(requestTypeList))
    cloneRequestTypeList.splice(index,0,props.pouRequestTypes)
    setRequestTypeList(cloneRequestTypeList)
  }
  
  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdCard title="General Information">
          <Container>
            {!isDetail&&<div className='rowFields'>
              <Field
                name="poSelect"
                label="Select PO"
                placeHolder='PO No. Title'
                editable={(isCreate || isEdit)&&(valueForm&&valueForm.status!=5)}
                component={FieldInput}
                allowAdditions={false}
                loading={poComplete.loading}
                options={poComplete.data.map((m,i) => ({
                  key: `pu${i}`,
                  value: m.poSapNumber,
                  text: `${m.poSapNumber} ${m.title}`,
                }))}
                type={type.select}
                className='halfRow'
                require={!isDetail}
              />
            </div>}
            <div className="rowFields">
              <Field
                name="purchaseOrderNumber"
                label="PO No."
                type={type.text}
                component={FieldInput}
                editable={false}
                className='halfRow'
              />
              {valueForm&&valueForm.purchaseOrderNumber&&
              <Button size='mini' icon labelPosition='right' className='btnDetail' onClick={()=>window.open(purchaseOrderDetailPath(valueForm.purchaseOrderId||valueForm.poId),"_blank")}>
                PO Detail
                <Icon name='right arrow' />
              </Button>}
            </div>
            <div className="rowFields">
              <Field
                name="purchaseGroupCode"
                label="Purchasing Group"
                type={type.select}
                allowAdditions={false}
                options={props.purchasingGroups.data}
                loading={props.purchasingGroups.loading} 
                component={FieldInput}
                editable={(isCreate || isEdit)}
                require={!isDetail}
                className='halfRow'
              />
            </div>
            <div className="rowFields">
              <Field
                name="requestTypeCheck"
                label="Request type"
                type={type.text}
                component={FieldInput}
                require={!isDetail}
                dummy
              />
            </div>
            <React.Fragment>
              {!isDetail&&!checkRequestTypeIsCancelPO()?<Button 
                type='button'
                content='Add' 
                color='green'
                icon='plus' 
                labelPosition='right'
                style={{ marginRight: '5px',maxWidth:'10rem' }}
                onClick={()=>{
                  change('formPOUpdate',`requestTypes[${valueForm.requestTypes.length}].deleted`,false)
                }}
              />:null}
              <div style={{height:'1rem'}}/>
              <div style={{display:'flex', flexDirection:'column'}}>
                <div style={{display:'flex'}}>
                  {/* <RowHeader_ style={{flex:'.3'}}>No.</RowHeader_> */}
                  <RowHeader_ style={{flex:'4'}}>Request Type{' '}<span style={{color:'red'}}>*</span></RowHeader_>
                  <RowHeader style={{flex:'5'}}>Request Description{' '}<span style={{color:'red'}}>*</span></RowHeader>
                  {isDetail?null:
                  <RowHeader style={{flex:'.5'}}>Action</RowHeader>}
                </div>
                {valueForm&&valueForm.requestTypes&&valueForm.requestTypes.length?
                valueForm.requestTypes.map((con, index) => {
                  return !con.deleted?
                  <div style={{display:'flex'}} key={index}>
                    {/* <RowData_ style={{flex:'.3'}}>
                      {index+1}
                    </RowData_> */}
                    <RowData_ style={{flex:'4'}}>
                      <div style={{display:'flex',flexDirection:'column',flex:1}}>
                        <Field 
                          name={`requestTypes[${index}].code`}  
                          type={type.select}
                          editable={!isDetail}
                          component={FieldInput}
                          placeHolder='ระบุหัวข้อที่ต้องการเปลี่ยนแปลง'
                          options={requestTypeList[index]||[]}
                          noBorder
                        />
                        {checkRequestTypeIsCancelPO()?<Field
                          name={`requestTypes[${index}].cancelPr`}  
                          label="Cancel PR"
                          editable={!isDetail}
                          type={type.checkbox}
                          component={FieldInput}
                          style={{marginTop:'0.5rem'}}
                        />:null}
                      </div>
                    </RowData_>
                    <RowData style={{flex:'5'}}>
                      <Field 
                        name={`requestTypes[${index}].description`}  
                        type={type.textArea}
                        component={FieldInput}
                        editable={!isDetail}
                        placeHolder='ระบุรายละเอียดที่ต้องการเปลี่ยนแปลง'
                        resizeVerticalOnly
                      />
                    </RowData>
                    {isDetail?null:
                    <RowData style={{flex:'.5'}}>
                      <Icon circular name='trash alternate' color='red' link 
                        onClick={()=>{
                          change('formPOUpdate',`requestTypes[${index}].deleted`, true)
                          // let clone2 = JSON.parse(JSON.stringify(valueForm.requestTypes))
                          // clone2[index].deleted = true
                          // let c = 0
                          // change('formPOUpdate','requestTypes',clone2.map((x,i)=>{
                          //   return(
                          //     {...x,lineNo:x.deleted?x.lineNo:c+=1}
                          //   )
                          // }))
                        }}
                      />
                    </RowData>}
                  </div>:null
                })
                :
                <RowNF>Request Type not found</RowNF>
                }
              </div>
            </React.Fragment>
            <div style={{height:'1rem'}}/>
            <div className="rowFields">
              <Field
                name="priority"
                label="Priority"
                type={type.radio}
                options={[
                  { text: 'Normal', value: 'Normal' },
                  { text: 'Urgent', value: 'Urgent' }]}
                component={FieldInput}
                editable={((isCreate || isEdit))}
                horizontalView
                require={!isDetail}
              />
            </div>
            <div className="rowFields">
              <Field
                name='reasonOfChange'
                label='Remark'
                type={type.textArea}
                component={FieldInput}
                editable={((isCreate || isEdit))}
              />
            </div>
          </Container>
        </StdCard>
      <Confirm
        open={showConfirm01}
        content={<div className='content'>Do you want to change the request type to <b>"Cancel PO"</b>? If you click <b>"Yes"</b> will delete all the request type that you selected.</div>}
        confirmButton='Yes'
        cancelButton='No'
        size='tiny'
        closeOnDimmerClick={false}
        onCancel={()=>onRejectConfirm01()}
        onConfirm={()=>onAcceptConfirm01()}
      />
      <Modal
        open={showConfirm02}
        header={<div className='header' style={{color:'#FFCC00'}}>Warning!!</div>}
        closeOnDimmerClick={false}
        size='tiny'
        content={'Warning!! Down Payment or Contract that related to this PO will be cancel. Are you sure to continue cancel this PO?'}
        actions={[{ key: 'ok', content: 'OK', positive: true, onClick:()=>setShowConfirm02(false)}]}
      />
      <Modal
        open={showAlertHasGR}
        header={<div className='header' style={{color:'#FFCC00'}}>Warning!!</div>}
        closeOnDimmerClick={false}
        size='tiny'
        content={'Warning!! Cannot cancel this PO becuase that has been delivered complete. If you want to cancel you must cancel all goods/service reciept before create PO Update/Cancel request.'}
        actions={[{ key: 'ok', content: 'OK', positive: true, onClick:()=>setShowAlertHasGR(false)}]}
      />
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = state => {
  let valueForm = getFormValues('formPOUpdate')(state)
  let poComplete = state.poUpdate.poComplete
  return {
    purchasingGroups: state.options.purchasingGroups,
    valueForm:valueForm||{},
    poComplete,
    pouRequestTypes:state.poUpdate.pouRequestTypes.data,
    poCompleteDetail: state.poUpdate.poCompleteDetail.data,
  }
}

const mapDispatchToProps = {
  change,
  getPOURequestTypes,
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInfo)
